export const FINANCIAL_ACCOUNT_REPORT = `report/financial_account`;
